/* istanbul ignore file */
import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";

import { rootRouteRef } from "./routes";

export const circlesPlugin = createPlugin({
  id: "circles",
  routes: {
    root: rootRouteRef,
  },
});

export const CirclesPage = circlesPlugin.provide(
  createRoutableExtension({
    name: "CirclesPage",
    component: () =>
      import("./components/CirclesGraphPage").then((m) => m.CirclesGraphPage),
    mountPoint: rootRouteRef,
  })
);
